import { z } from 'zod';
import { IntegrationType } from './enums';

// JsonValue type for settings
type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
const JsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema) as z.ZodType<JsonValue[]>,
    z.record(z.string(), JsonValueSchema) as z.ZodType<{ [key: string]: JsonValue }>
  ])
) as z.ZodType<JsonValue>;

export const Integration = z.object({
  type: IntegrationType,
  id: z.string(),
  accessCode: z.string().nullable(),
  settings: JsonValueSchema.nullable(),
  workspaceId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type Integration = z.infer<typeof Integration>;

